// eslint-disable-next-line no-restricted-imports
import { OutlinedInput as MuiOutlinedInput } from '@mui/material';
import { forwardRef } from 'react';
import { OutlinedInputProps } from './mui-index';

export const OutlinedInput = forwardRef(({ classes, ...props }: OutlinedInputProps, ref) => (
  <MuiOutlinedInput classes={{ ...(classes ?? {}), input: 'data-hj-allow' }} ref={ref} {...props} />
));
